import {DeviceResponseDto} from '../models/device-response.interface';

type DeviceValueLike = Pick<
  DeviceResponseDto,
  'value' | 'pendingValue' | 'pendingState' | 'pendingAttemptCount'
>;

export const getDisplayedDeviceValue = (device?: DeviceValueLike | null): string | null => {
  if (device?.pendingValue !== undefined && device?.pendingValue !== null) {
    return String(device.pendingValue);
  }

  return device?.value ?? null;
};

export const isDeviceActive = (device?: DeviceValueLike | null): boolean =>
  getDisplayedDeviceValue(device) === 'true';

export const isDevicePending = (device?: DeviceValueLike | null): boolean =>
  device?.pendingValue != null ||
  device?.pendingState != null ||
  device?.pendingAttemptCount != null;
